import { FC, memo } from 'react'
import { createIcon } from '@chakra-ui/icons'

import { CustomIconProps } from 'types'
import CustomIcon from '../../CustomIcon'

const UserGuardOutline = createIcon({
  displayName: 'UserHexagonOutline',
  viewBox: '0 0 24 24',
  path: (
    <>
      <g strokeLinecap="round" strokeWidth="1.5" stroke="currentColor" fill="none" strokeLinejoin="round">
        <polygon points="0 0 24 0 24 24 0 24" fill-rule="evenodd" stroke="none" fill="none" />
        <path
          d="M11.083 14.75C11.4972 14.75 11.833 15.0858 11.833 15.5 11.833 15.8797 11.5508 16.1935 11.1848 16.2432L11.083 16.25H8.5C6.42921 16.25 4.75 17.9292 4.75 20 4.75 20.4142 4.41421 20.75 4 20.75 3.58579 20.75 3.25 20.4142 3.25 20 3.25 17.1733 5.48472 14.8679 8.28362 14.7544L8.5 14.75H11.083Z"
          stroke="none"
          fill="currentColor"
        />
        <path
          d="M16.5724 14.5752L14.7531 15.2269C14.4557 15.3335 14.2569 15.6149 14.256 15.9308L14.25 18.0138C14.25 19.0669 14.8335 19.9733 15.7673 20.7545 16.2912 21.1928 16.8096 21.5026 17.1735 21.6766 17.378 21.7744 17.6158 21.7745 17.8203 21.6767 18.1842 21.5029 18.7027 21.1932 19.2266 20.7551 20.1604 19.9742 20.744 19.0679 20.744 18.017L20.75 15.9352C20.7509 15.6176 20.5518 15.3339 20.2528 15.2269L18.4318 14.5749C17.8304 14.3593 17.1733 14.3593 16.5724 14.5752ZM17.9259 15.987L19.248 16.461 19.244 18.0148C19.244 18.5323 18.8912 19.0803 18.2644 19.6044L18.018 19.7984C17.9062 19.8815 17.7916 19.9602 17.6762 20.0343L17.488 20.149 17.3248 20.0532C16.5031 19.5488 15.75 18.7898 15.75 18.016L15.753 16.461 17.0789 15.9871C17.3527 15.8887 17.6516 15.8887 17.9259 15.987Z"
          stroke="none"
          fill="currentColor"
        />
        <path
          d="M8.46446 4.71447C10.4171 2.76185 13.5829 2.76185 15.5355 4.71447 17.4882 6.66709 17.4882 9.83292 15.5355 11.7855 13.5829 13.7382 10.4171 13.7382 8.46446 11.7855 6.51184 9.83292 6.51184 6.66709 8.46446 4.71447ZM14.3253 5.63391C12.9508 4.41004 10.8431 4.45711 9.52512 5.77513 8.15828 7.14197 8.15828 9.35804 9.52512 10.7249 10.892 12.0917 13.108 12.0917 14.4749 10.7249 15.7929 9.40686 15.84 7.29918 14.6161 5.92475L14.4749 5.77513 14.3253 5.63391Z"
          stroke="none"
          fill="currentColor"
        />
      </g>
    </>
  ),
})

const UserHexagon: FC<CustomIconProps> = (props) => {
  return <CustomIcon as={UserGuardOutline} {...props} />
}

export default memo(UserHexagon)
